
import {
  defineComponent,
  reactive,
  ref,
  computed,
  onMounted,
  watch,
  onUnmounted,
  watchEffect,
} from "vue";
import InputText from "primevue/inputtext";
import Textarea from "primevue/textarea";
import Rating from "primevue/rating";
import Calendar from "primevue/calendar";
import Button from "primevue/button";
import Card from "primevue/card";
import RecipeSource from "../RecipeForm/RecipeSource";
import RecipeIngredients from "./RecipeIngredients";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { Recipe, AppState } from "@/store/types";
import { RATING_MAX } from "@/static/data.config";
import {
  timestampsToDates,
  getTheLargestNumber,
} from "@/services/utils.service";
export default defineComponent({
  components: {
    InputText,
    Textarea,
    Rating,
    Calendar,
    Button,
    RecipeSource,
    RecipeIngredients,
    Card,
  },
  setup() {
    const store = useStore<AppState>();
    const route = useRoute();
    const router = useRouter();
    const recipeId = route.params.id;
    const selectedDates = ref<Date[]>([]);
    const maxInputValue = ref<Date>(new Date());
    const recipe = computed(() => store.state.activeRecipe);
    const user = computed(() => store.state.user);
    const form: Partial<Recipe> = reactive({
      name: "",
      notes: "",
      rating: 1,
      source: "link",
      ingredients: [],
    });
    const allIngredients = ref([]);
    const isSourceValid = ref(true);
    const isNameValid = ref(true);

    const updateForm = (values: Partial<Recipe>) => {
      Object.assign(form, values);
      if (values.dates?.length)
        selectedDates.value = timestampsToDates(values.dates);
    };

    watchEffect(() => {
      if (!recipe.value) return;

      updateForm(recipe.value);
    });

    const selectedDatesAsTimestamps = () => {
      return selectedDates.value?.map((date) => new Date(date).getTime());
    };

    const submitForm = () => {
      if (!isSourceValid.value) return;
      if (selectedDates.value.length) {
        form.dates = selectedDatesAsTimestamps();
        form.lastUsed = getTheLargestNumber(form.dates);
      }
      if (recipeId) {
        store.dispatch("updateRecipe", { id: recipeId, ...form });
        router.push({ name: "recipe", params: { id: recipeId } });
      } else {
        const creationDate = new Date().getTime();
        store.dispatch("createRecipe", { creationDate, ...form });
        router.push({ name: "list" });
      }
    };

    const getRecipeDataById = () => {
      if (recipeId) {
        store.dispatch("fetchRecipeById", recipeId);
      }
    };

    const checkValidation = () => {
      isNameValid.value = !!form.name;
    };

    onMounted(() => {
      getRecipeDataById();
    });

    watch(user, () => {
      if (user.value) getRecipeDataById();
    });

    onUnmounted(() => {
      store.dispatch("resetActiveRecipe");
    });

    return {
      form,
      allIngredients,
      selectedDates,
      isNameValid,
      isSourceValid,
      recipe,
      RATING_MAX,
      maxInputValue,
      submitForm,
      updateForm,
      checkValidation,
    };
  },
});
